'use strict';

angular.module('shiftTraderApp')
    .service('SubscriptionPlansService', ['$http', 'ServerUrls', '$q', function ($http, ServerUrls, $q) {
    // this list MUST have all unique id's
      var plans = [
        // pricing iteration 2
        {
          num_emp_start: 1,
          num_emp_end: 29,
          amount: 4700,
          id: 'M-G-L1',
          pricingIteration: 'v2'
        },
        {
          num_emp_start: 30,
          num_emp_end: 49,
          amount: 6700,
          id: 'M-G-L2',
          pricingIteration: 'v2'
        },
        {
          num_emp_start: 50,
          num_emp_end: 69,
          amount: 8700,
          id: 'M-G-L3',
          pricingIteration: 'v2'
        },
        {
          num_emp_start: 70,
          num_emp_end: 89,
          amount: 10700,
          id: 'M-G-L4',
          pricingIteration: 'v2'
        },
        {
          num_emp_start: 90,
          num_emp_end: 109,
          amount: 12700,
          id: 'M-G-L5',
          pricingIteration: 'v2'
        },
        {
          num_emp_start: 110,
          num_emp_end: 129,
          amount: 14700,
          id: 'M-G-L6',
          pricingIteration: 'v2'
        },
        {
          num_emp_start: 130,
          num_emp_end: 149,
          amount: 16700,
          id: 'M-G-L7',
          pricingIteration: 'v2'
        },
        {
          title: '150+',
          price: 'Call Us',
          id: 'CallIn',
          pricingIteration: 'v2'
        },
        // pricing Iteration 1
        {
          num_emp_start: 10,
          num_emp_end: 19,
          amount: 1700,
          id: 'M-S-L1',
          pricingIteration: 'v1'
        },
        {
          num_emp_start: 20,
          num_emp_end: 29,
          amount: 2700,
          id: 'M-S-L2',
          pricingIteration: 'v1'
        },
        {
          num_emp_start: 30,
          num_emp_end: 39,
          amount: 3700,
          id: 'M-S-L3',
          pricingIteration: 'v1'
        },
        {
          num_emp_start: 40,
          num_emp_end: 49,
          amount: 4700,
          id: 'M-S-L4',
          pricingIteration: 'v1'
        },
        {
          num_emp_start: 50,
          num_emp_end: 59,
          amount: 5700,
          id: 'M-S-L5',
          pricingIteration: 'v1'
        },
        {
          num_emp_start: 60,
          num_emp_end: 69,
          amount: 6700,
          id: 'M-S-L6',
          pricingIteration: 'v1'
        },
        {
          num_emp_start: 70,
          num_emp_end: 79,
          amount: 7700,
          id: 'M-S-L7',
          pricingIteration: 'v1'
        },
        {
          num_emp_start: 80,
          num_emp_end: 89,
          amount: 8700,
          id: 'M-S-L8',
          pricingIteration: 'v1'
        },
        {
          num_emp_start: 90,
          num_emp_end: 99,
          amount: 9700,
          id: 'M-S-L9',
          pricingIteration: 'v1'
        },
        {
          title: '100+',
          price: 'Call Us',
          id: 'CallInOld',
          pricingIteration: 'v1'
        }
      ];

      function initPlan(planData) {
        var p = _.merge({}, planData);

        if (planData.pricingIteration === 'v1' || planData.pricingIteration === 'v2') {
          p.has_types = false;
          p.interval = 'month';
          p.interval_count = 1;

          if (!p.title) {
            p.title = p.num_emp_start + '-' + p.num_emp_end;
          }

          if (!p.price) {
            p.price = '$' + parseInt(p.amount / 100);
          }
        } else {
          p.has_types = true;
          p.title = p.num_emp_start + '-' + p.num_emp_end;
          p.price = '$' + parseInt(p.amount / 100);
        }

        if (p.interval === 'month') {
          p.shortIntervalString = 'mo';
        } else if (p.interval === 'year') {
          p.shortIntervalString = 'yr';
        }



        return p;
      }

      plans = _.map(plans, initPlan);

      var getPlans = function(pricingIteration) {
        var deferred = $q.defer();
        if (_.isUndefined(pricingIteration)) {
          pricingIteration = 'v3';
        }

        if (_.contains(['v1', 'v2'], pricingIteration)) {
          deferred.resolve(_.where(plans, {pricingIteration: pricingIteration}));
        } else {
          $http.get(ServerUrls.current.railsApi + 'plans')
            .then(function(response) {
              var newPlans = _.map(response.data, initPlan);
              plans = plans.concat(newPlans);
              deferred.resolve(newPlans);
            }, function(response) {
              deferred.reject(response);
            })
        }
        return deferred.promise;
      };

      var getPlanById = function(planId) {
        var deferred = $q.defer();

        if (_.find(plans, {id: planId})) {
          deferred.resolve(_.find(plans, {id: planId}));
        } else {
          getPlans('v3')
            .then(function(plans) {
              deferred.resolve(_.find(plans, {id: planId}));
            }, function() {
              deferred.reject();
            })
        }
        return deferred.promise;
      };

      return {
        getPlans: getPlans,
        getPlanById: getPlanById
      };

    }]);
